/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./LayoutCenter.vue?vue&type=template&id=28619c98&scoped=true"
import script from "./LayoutCenter.vue?vue&type=script&lang=js"
export * from "./LayoutCenter.vue?vue&type=script&lang=js"
import style0 from "./LayoutCenter.vue?vue&type=style&index=0&id=28619c98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28619c98",
  null
  
)

export default component.exports